'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

const ROLE_LABELS: Record<string, string> = {
  portal_admin: 'Portal admin',
  club_manager: 'Responsabile club',
  team_manager: 'Responsabile squadra',
}

export function ImpersonationBanner({ name, role }: { name: string; role?: string }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  async function stop() {
    setLoading(true)
    try {
      await fetch('/api/portal/impersonate/stop', { method: 'POST' })
      router.push('/portal/admin/utenti')
      router.refresh()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="sticky top-0 z-[var(--z-banner)] flex flex-wrap items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-[14px] font-semibold text-white shadow">
      <span>
        Stai impersonando <strong>{name}</strong>
        {role && ROLE_LABELS[role] ? ` (${ROLE_LABELS[role]})` : ''} — le azioni sono registrate.
      </span>
      <button
        type="button"
        onClick={stop}
        disabled={loading}
        className="rounded-md bg-white/95 px-3 py-1 text-[12px] font-bold text-amber-700 disabled:opacity-60"
      >
        {loading ? 'Uscita…' : 'Termina impersonazione'}
      </button>
    </div>
  )
}
